import { Button, Heading, Text, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputTextMask } from "components/Atomos/Form/Elements/InputTextMask";
import { FormComponentProps } from "models/loginForm";
import { ForgotPasswordFormData, forgotPasswordSchema } from "models/password-reset.model";
import { useState } from "react";
import { useForm } from "react-hook-form";
import masks from "utils/masks/masks";

type ForgotPasswordFormProps = FormComponentProps<ForgotPasswordFormData>;

const ForgotPasswordForm = ({
    onSuccess,
    onFailed
}: ForgotPasswordFormProps) => {

    const { control, formState: { errors }, handleSubmit } = useForm<ForgotPasswordFormData>({
        resolver: yupResolver(forgotPasswordSchema)
    });

    const [submitting, setSubmitting] = useState(false);
    const handleSubmitClick = async (data: ForgotPasswordFormData) => {
        try {
            setSubmitting(true);
            await onSuccess(data);
        } catch (err) {
            onFailed?.(err);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <VStack p={8} spacing={4} w="full" as="form" onSubmit={handleSubmit(handleSubmitClick)}>
            <Heading>Esqueci minha senha</Heading>
            <Text>Informe seu CPF e você receberá um e-mail para fazer a alteração de sua nova senha, caso seu e-mail esteja cadastrado.</Text>
            <InputTextMask
                name="cpf"
                label="CPF"
                mask={masks.BRL_CPF}
                control={control}
                error={errors?.cpf}
            />
            <Button type="submit" isLoading={submitting}>Enviar e-mail</Button>
        </VStack>
    )
}
export default ForgotPasswordForm